import React from "react";
import {
  Typography, Grid, TextField, Switch, FormControlLabel,
  Accordion, AccordionSummary, AccordionDetails, Divider, Paper
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

const areeTecniche = [
  { id: "audio", label: "Acquisizione e distribuzione audio in sala" },
  { id: "video", label: "Riprese video" },
  { id: "connessione", label: "Connessione" },
  { id: "regia", label: "Regia" },
  { id: "contributi", label: "Gestione contributi in sala" },
  { id: "trasmissione", label: "Trasmissione a pubblico remoto" },
  { id: "relatori", label: "Presenza relatori remoti" },
  { id: "noleggioMateriale", label: "Noleggio materiale" },
];

const serviziAggiuntivi = [
  { id: "glamotion", label: "Glamotion" },
  { id: "multiLanguage", label: "MultiLanguage" },
  { id: "votazioniLumi", label: "Votazioni LUMI" },
];

export default function SezionePreventivo({ form, handleChange, handleArea }) {
  function handleServizio(servizioId, field, value) {
    const nuoviServizi = {
      ...(form.servizi || {}),
      [servizioId]: {
        ...(form.servizi?.[servizioId] || {}),
        [field]: value,
      },
    };
    handleChange("servizi", nuoviServizi);
  }

  return (
    <Accordion elevation={1} sx={{ mb: 2 }}>
      <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ backgroundColor: "#FFF3CD" }}>
        <Typography fontWeight="bold">Requirements cliente</Typography>
      </AccordionSummary>
      <AccordionDetails>
        <Grid container spacing={2} mt={0}>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Data evento" type="date"
              value={form.data || ""}
              onChange={(e) => handleChange("data", e.target.value)}
              InputLabelProps={{ shrink: true }} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Location"
              value={form.location || ""}
              onChange={(e) => handleChange("location", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Budget indicativo (€)" type="number"
              value={form.budget || ""}
              onChange={(e) => handleChange("budget", e.target.value)} />
          </Grid>
          <Grid item xs={12} md={6}>
            <TextField fullWidth label="Opportunità SuiteCRM"
              value={form.opportunitaCRM || ""}
              onChange={(e) => handleChange("opportunitaCRM", e.target.value)} />
          </Grid>
          <Grid item xs={12}>
            <TextField fullWidth multiline rows={3}
              label="Nominativi e contatti di riferimento"
              placeholder="Inserisci i contatti dei referenti del progetto"
              value={form.contattiReferenti || ""}
              onChange={(e) => handleChange("contattiReferenti", e.target.value)} />
          </Grid>

          {/* REQUISITI TECNICI */}
          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2" fontWeight="bold" color="text.secondary" mb={1}>
              Requisiti tecnici
            </Typography>
          </Grid>
          {areeTecniche.map((area) => (
            <Grid item xs={12} key={area.id}>
              <FormControlLabel
                control={
                  <Switch
                    checked={form.aree?.[area.id]?.attiva || false}
                    onChange={(e) => handleArea(area.id, "attiva", e.target.checked)}
                    color="primary"
                  />
                }
                label={<Typography fontWeight="medium">{area.label}</Typography>}
              />
              {form.aree?.[area.id]?.attiva && (
                <TextField
                  fullWidth multiline rows={2}
                  label="Note e dettagli"
                  value={form.aree?.[area.id]?.note || ""}
                  onChange={(e) => handleArea(area.id, "note", e.target.value)}
                  sx={{ mt: 1, ml: 4 }}
                />
              )}
            </Grid>
          ))}

          {/* SERVIZI AGGIUNTIVI */}
          <Grid item xs={12}>
            <Divider sx={{ my: 1 }} />
            <Typography variant="body2" fontWeight="bold" color="text.secondary" mb={1}>
              Servizi aggiuntivi
            </Typography>
          </Grid>
          {serviziAggiuntivi.map((servizio) => (
            <Grid item xs={12} key={servizio.id}>
              <FormControlLabel
                control={
                  <Switch
                    checked={form.servizi?.[servizio.id]?.attivo || false}
                    onChange={(e) => handleServizio(servizio.id, "attivo", e.target.checked)}
                    color="secondary"
                  />
                }
                label={<Typography fontWeight="medium">{servizio.label}</Typography>}
              />
              {form.servizi?.[servizio.id]?.attivo && (
                <TextField
                  fullWidth multiline rows={2}
                  label="Note e dettagli"
                  value={form.servizi?.[servizio.id]?.note || ""}
                  onChange={(e) => handleServizio(servizio.id, "note", e.target.value)}
                  sx={{ mt: 1, ml: 4 }}
                />
              )}
            </Grid>
          ))}
        </Grid>
      </AccordionDetails>
    </Accordion>
  );
}